module.exports = __webpack_public_path__ + "media/images/brandsFacebookPage-a7c8b615.png";